import React, { useEffect } from "react"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import { useFormContext } from "react-hook-form"
import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { LeftBackArrowImage } from "components/views/fle/Molecules"
import { FormSingleSelect } from "components/views/atoms/forms/FormSingleSelect"
import { Body } from "components/views/atoms/Bodies"
import { SelectProps } from "@carrotfertility/carotene/dist/components/Select"

interface BenefitEnrollmentFlowModalBackButtonProps {
  handleGoBack?: () => void
}
export function BenefitEnrollmentFlowModalBackButton({
  handleGoBack
}: BenefitEnrollmentFlowModalBackButtonProps): JSX.Element {
  const { gotoPreviousStep } = useStateMachine()

  return (
    <div
      className="pointer bg-carrot-orange-01 br-100 flex items-center justify-center"
      style={{
        height: "2rem",
        width: "2rem"
      }}
      onClick={handleGoBack || gotoPreviousStep}
    >
      <LeftBackArrowImage />
    </div>
  )
}

export function BenefitEnrollmentModalContinueButton({ onClick }: { onClick: () => void }): JSX.Element {
  return (
    <div className="fr">
      <ArrowLink onClickOnly to="#" onClick={onClick} weight="fw5" TextComponent={Body}>
        Continue
      </ArrowLink>
    </div>
  )
}

export function BenefitEnrollmentModalFormSelect({
  defaultValue = null,
  name,
  options,
  ...otherProps
}: SelectProps): JSX.Element {
  const { setValue } = useFormContext()
  const value = defaultValue !== null ? String(defaultValue) : null
  useEffect(() => {
    setValue(
      name,
      options.find(({ id }) => id === value)
    )
  }, [])
  return <FormSingleSelect rules={{ required: "Required" }} {...{ ...otherProps, name, options }} />
}

export { default as DateOfBirth } from "./DateOfBirthWithLabels"
export { default as EnrollmentStepFormLayout } from "./EnrollmentStepFormLayout"
